import api from '@/services/api';

export interface SessionLogUpload {
  uploadId: string;
  provider: string;
  fileName: string;
  sizeBytes: number;
  status: 'pending' | 'uploaded';
  createdBy: string;
  createdAtUnixMs: number;
  uploadedAtUnixMs: number;
}

export interface ListSessionLogsReply {
  uploads: SessionLogUpload[];
  providers: string[];
  nextCursor: string;
}

export interface PreviewSessionLogReply {
  uploadId: string;
  contentBase64: string;
  nextCursor: string;
  hasMore: boolean;
}

export interface DownloadSessionLogReply {
  upload: SessionLogUpload;
  downloadUrl: string;
  expiresAtUnixMs: number;
}

const base = '/api/v1/session-log-uploads';

export const sessionLogsApi = {
  content: (uploadId: string, signal?: AbortSignal) =>
    api.get<never, ArrayBuffer>(
      `${base}/${encodeURIComponent(uploadId)}/content`,
      { responseType: 'arraybuffer', timeout: 120_000, signal },
    ),
  download: (uploadId: string, signal?: AbortSignal) =>
    api.get<never, DownloadSessionLogReply>(
      `${base}/${encodeURIComponent(uploadId)}/download`,
      { signal },
    ),
  list: (
    params: { provider?: string; pageSize: number; cursor?: string },
    signal?: AbortSignal,
  ) => api.get<never, ListSessionLogsReply>(base, { params, signal }),
  preview: (uploadId: string, cursor?: string, signal?: AbortSignal) =>
    api.get<never, PreviewSessionLogReply>(
      `${base}/${encodeURIComponent(uploadId)}/preview`,
      { params: { cursor }, signal },
    ),
};
